<div class="container">
  <app-template [title]="'View Logs'">
    <div class="all">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          id="search-text"
          aria-describedby="search-text"
          [(ngModel)]="searchText"
          placeholder="Search name"
          autofocus
        />
      </div>
      <table *ngIf="!isLoading" style="width: 100%">
        <tr class="back">
          <th>Mode</th>
          <th>Receiver</th>
          <th>Subject</th>
          <th></th>
        </tr>
        <tr class="td" *ngFor="let logs of filterdlogs">
          <td>{{ logs.Mode }}</td>
          <td>{{ logs.Receiver }}</td>
          <td>{{ logs.Subject }}</td>
          <td></td>
        </tr>
      </table>
    </div>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
      <div class="space"></div>
    </div>
    <div class="space"></div>
  </app-template>
</div>
